import { Card, Field, StringList, inputCls } from "./fields";

export default function ContentTab({ data = {}, onChange, idSuffix = "" }) {
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <Card title="القسم الرئيسي (Hero)" testid={`admin-card-hero${idSuffix}`}>
        <Field label="الشارة العلوية">
          <input className={inputCls} data-testid={`admin-hero-badge${idSuffix}`} value={data?.hero?.badge || ""} onChange={(e) => onChange("hero", "badge", e.target.value)} />
        </Field>
        <Field label="العنوان — السطر الأول">
          <input className={inputCls} data-testid={`admin-hero-title-top${idSuffix}`} value={data?.hero?.titleTop || ""} onChange={(e) => onChange("hero", "titleTop", e.target.value)} />
        </Field>
        <Field label="العنوان — السطر الثاني (ذهبي)">
          <input className={inputCls} data-testid={`admin-hero-title-bottom${idSuffix}`} value={data?.hero?.titleBottom || ""} onChange={(e) => onChange("hero", "titleBottom", e.target.value)} />
        </Field>
        <Field label="الوصف">
          <textarea rows={3} className={inputCls} data-testid={`admin-hero-subtitle${idSuffix}`} value={data?.hero?.subtitle || ""} onChange={(e) => onChange("hero", "subtitle", e.target.value)} />
        </Field>
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label="نص زر واتساب">
            <input className={inputCls} data-testid={`admin-hero-cta${idSuffix}`} value={data?.hero?.ctaText || ""} onChange={(e) => onChange("hero", "ctaText", e.target.value)} />
          </Field>
          <Field label="ملاحظة أسفل الزر">
            <input className={inputCls} data-testid={`admin-hero-note${idSuffix}`} value={data?.hero?.ctaNote || ""} onChange={(e) => onChange("hero", "ctaNote", e.target.value)} />
          </Field>
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label="رابط Google Play (اتركه فارغاً = زر مؤقت)">
            <input dir="ltr" className={`${inputCls} text-left`} data-testid={`admin-hero-googleplay${idSuffix}`} value={data?.hero?.googlePlayUrl || ""} onChange={(e) => onChange("hero", "googlePlayUrl", e.target.value)} />
          </Field>
          <Field label="رابط App Store">
            <input dir="ltr" className={`${inputCls} text-left`} data-testid={`admin-hero-appstore${idSuffix}`} value={data?.hero?.appStoreUrl || ""} onChange={(e) => onChange("hero", "appStoreUrl", e.target.value)} />
          </Field>
        </div>
      </Card>

      <Card title="قسم من نحن" testid={`admin-card-about${idSuffix}`}>
        <Field label="العنوان الصغير">
          <input className={inputCls} data-testid={`admin-about-eyebrow${idSuffix}`} value={data?.about?.eyebrow || ""} onChange={(e) => onChange("about", "eyebrow", e.target.value)} />
        </Field>
        <Field label="العنوان الرئيسي">
          <input className={inputCls} data-testid={`admin-about-title${idSuffix}`} value={data?.about?.title || ""} onChange={(e) => onChange("about", "title", e.target.value)} />
        </Field>
        <Field label="النص التعريفي">
          <StringList items={data?.about?.paragraphs || []} onChange={(v) => onChange("about", "paragraphs", v)} addLabel="+ إضافة فقرة" />
        </Field>
        <Field label="نقاط سريعة">
          <StringList items={data?.about?.points || []} onChange={(v) => onChange("about", "points", v)} addLabel="+ إضافة نقطة" />
        </Field>
      </Card>

      <Card title="قسم لقطات التطبيق" testid={`admin-card-gallery${idSuffix}`}>
        <Field label="العنوان الصغير">
          <input className={inputCls} data-testid={`admin-gallery-eyebrow${idSuffix}`} value={data?.gallery?.eyebrow || ""} onChange={(e) => onChange("gallery", "eyebrow", e.target.value)} />
        </Field>
        <Field label="العنوان الرئيسي">
          <input className={inputCls} data-testid={`admin-gallery-title${idSuffix}`} value={data?.gallery?.title || ""} onChange={(e) => onChange("gallery", "title", e.target.value)} />
        </Field>
        <Field label="الوصف">
          <input className={inputCls} data-testid={`admin-gallery-subtitle${idSuffix}`} value={data?.gallery?.subtitle || ""} onChange={(e) => onChange("gallery", "subtitle", e.target.value)} />
        </Field>
      </Card>

      <Card title="قسم كيف يعمل" testid={`admin-card-steps${idSuffix}`}>
        <Field label="العنوان الصغير">
          <input className={inputCls} data-testid={`admin-steps-eyebrow${idSuffix}`} value={data?.steps?.eyebrow || ""} onChange={(e) => onChange("steps", "eyebrow", e.target.value)} />
        </Field>
        <Field label="العنوان الرئيسي">
          <input className={inputCls} data-testid={`admin-steps-title${idSuffix}`} value={data?.steps?.title || ""} onChange={(e) => onChange("steps", "title", e.target.value)} />
        </Field>
        {(data?.steps?.items || []).map((step, i) => (
          <div key={i} className="rounded-xl border border-line bg-white p-4">
            <p className="mb-3 text-xs font-bold text-gold-dark">الخطوة {i + 1}</p>
            <div className="space-y-3">
              <input
                className={inputCls}
                placeholder="عنوان الخطوة"
                data-testid={`admin-step-${i}-title${idSuffix}`}
                value={step?.title || ""}
                onChange={(e) => {
                  const items = [...(data?.steps?.items || [])];
                  items[i] = { ...items[i], title: e.target.value };
                  onChange("steps", "items", items);
                }}
              />
              <textarea
                rows={2}
                className={inputCls}
                placeholder="وصف الخطوة"
                data-testid={`admin-step-${i}-desc${idSuffix}`}
                value={step?.desc || ""}
                onChange={(e) => {
                  const items = [...(data?.steps?.items || [])];
                  items[i] = { ...items[i], desc: e.target.value };
                  onChange("steps", "items", items);
                }}
              />
            </div>
          </div>
        ))}
      </Card>

      <Card title="قسم أصحاب الصالونات" testid={`admin-card-owners${idSuffix}`}>
        <Field label="العنوان الصغير">
          <input className={inputCls} data-testid={`admin-owners-eyebrow${idSuffix}`} value={data?.owners?.eyebrow || ""} onChange={(e) => onChange("owners", "eyebrow", e.target.value)} />
        </Field>
        <Field label="العنوان الرئيسي">
          <input className={inputCls} data-testid={`admin-owners-title${idSuffix}`} value={data?.owners?.title || ""} onChange={(e) => onChange("owners", "title", e.target.value)} />
        </Field>
        <Field label="النص">
          <textarea rows={3} className={inputCls} data-testid={`admin-owners-text${idSuffix}`} value={data?.owners?.text || ""} onChange={(e) => onChange("owners", "text", e.target.value)} />
        </Field>
        <Field label="الفوائد (نقاط)">
          <StringList items={data?.owners?.bullets || []} onChange={(v) => onChange("owners", "bullets", v)} addLabel="+ إضافة فائدة" />
        </Field>
        <Field label="نص زر الدعوة">
          <input className={inputCls} data-testid={`admin-owners-cta${idSuffix}`} value={data?.owners?.ctaText || ""} onChange={(e) => onChange("owners", "ctaText", e.target.value)} />
        </Field>
      </Card>

      <Card title="تذييل الصفحة والصفحات القانونية" testid={`admin-card-footer${idSuffix}`}>
        <Field label="نبذة التذييل">
          <textarea rows={2} className={inputCls} data-testid={`admin-footer-about${idSuffix}`} value={data?.footer?.about || ""} onChange={(e) => onChange("footer", "about", e.target.value)} />
        </Field>
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label="المدينة / الدولة">
            <input className={inputCls} data-testid={`admin-footer-city${idSuffix}`} value={data?.footer?.city || ""} onChange={(e) => onChange("footer", "city", e.target.value)} />
          </Field>
          <Field label="البريد الإلكتروني (اتركه فارغاً لإخفائه)">
            <input dir="ltr" className={`${inputCls} text-left`} data-testid={`admin-footer-email${idSuffix}`} value={data?.footer?.email || ""} onChange={(e) => onChange("footer", "email", e.target.value)} />
          </Field>
        </div>
        <Field label="عنوان سياسة الخصوصية">
          <input className={inputCls} data-testid={`admin-footer-privacy-title${idSuffix}`} value={data?.footer?.privacyTitle || ""} onChange={(e) => onChange("footer", "privacyTitle", e.target.value)} />
        </Field>
        <Field label="نص سياسة الخصوصية">
          <StringList items={data?.footer?.privacyText || []} onChange={(v) => onChange("footer", "privacyText", v)} addLabel="+ إضافة فقرة" />
        </Field>
        <Field label="عنوان شروط الاستخدام">
          <input className={inputCls} data-testid={`admin-footer-terms-title${idSuffix}`} value={data?.footer?.termsTitle || ""} onChange={(e) => onChange("footer", "termsTitle", e.target.value)} />
        </Field>
        <Field label="نص شروط الاستخدام">
          <StringList items={data?.footer?.termsText || []} onChange={(v) => onChange("footer", "termsText", v)} addLabel="+ إضافة فقرة" />
        </Field>
      </Card>
    </div>
  );
}
